import { faqCollectionBodySchema } from "@redotech/redo-model/faq/faq-body-schema";
import * as z from "zod/v4";

export const getFaqCollections = {
  name: "getFaqCollections" as const,
  input: z.object({}),
  output: z.object({ collections: z.array(faqCollectionBodySchema) }),
};
